import React, { forwardRef, memo, useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, FormControl, FormGroup } from "react-bootstrap";
import { fonts } from "../constants";

const CustomMenu = forwardRef(({ children, className }, ref) => {
  const [value, setValue] = useState("");

  return (
    <div ref={ref} className={className}>
      <FormGroup className="setting-form-group mx-3 my-2 w-auto">
        <FormControl
          autoFocus
          className="setting-input"
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />
      </FormGroup>
      <ul
        className="list-unstyled"
        style={{
          maxWidth: "300px",
        }}
      >
        {React.Children.toArray(children).filter(
          (child) =>
            !value ||
            child.props.children.toLowerCase().includes(value.toLowerCase())
        )}
      </ul>
    </div>
  );
});

const SearchbarDropdown = ({ handleChangeFont, font, keyTest }) => {
  const handleSelect = (item) => {
    const text = item.font;
    if (font !== text) {
      handleChangeFont(item);
    }
  };

  return (
    <Dropdown>
      <Dropdown.Toggle
        data-testid={`select-font-${keyTest}`}
        id="dropdown-font"
        variant="outline-dark"
        className="d-flex align-items-center justify-content-between dropdown-font"
      >
        <p
          className="m-0 text-truncate d-inline-block"
          style={{
            fontFamily: font,
          }}
          data-testid={`selected-font-${keyTest}`}
        >
          {font}
        </p>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-font-menu" as={CustomMenu}>
        {fonts.map(({ fontFamily, format }, index) => {
          return (
            <Dropdown.Item
              onClick={() =>
                handleSelect({
                  font: fontFamily,
                  format: format,
                })
              }
              style={{ fontFamily: `"${fontFamily}", 'sans-serif'` }}
              className="text-truncate"
              key={index}
              data-testid={`font-item-${keyTest}-${fontFamily}`}
            >
              {fontFamily}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

SearchbarDropdown.propTypes = {
  font: PropTypes.string,
  keyTest: PropTypes.string,
  handleChangeFont: PropTypes.func,
};

CustomMenu.displayName = "CustomMenu";

CustomMenu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default memo(
  SearchbarDropdown,
  (prevProps, nextProps) => prevProps.font === nextProps.font
);
